import { useEffect, type PropsWithChildren } from 'react';

import { CenteredLoadingIndicator } from '@storebrand-digital/bank-foundation-components';

import auth from '../../auth';
import { logError } from '../../logger';

export default function Protected({ children }: PropsWithChildren) {
  useEffect(() => {
    if (!auth.authenticated) {
      auth.login().catch(logError);
    }
  }, []);

  return auth.authenticated ? <>{children}</> : <CenteredLoadingIndicator isFixed />;
}
